// extracted by mini-css-extract-plugin
export default {"distance":"distance_gDx4lUo7","distanceText":"distanceText_Y_7Xm4OG","spacingElement":"spacingElement_CjI5wKUL"};